import { render, staticRenderFns } from "./goods_form.vue?vue&type=template&id=606106ed&scoped=true&"
import script from "./goods_form.vue?vue&type=script&lang=js&"
export * from "./goods_form.vue?vue&type=script&lang=js&"
import style0 from "./goods_form.vue?vue&type=style&index=0&id=606106ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606106ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('606106ed')) {
      api.createRecord('606106ed', component.options)
    } else {
      api.reload('606106ed', component.options)
    }
    module.hot.accept("./goods_form.vue?vue&type=template&id=606106ed&scoped=true&", function () {
      api.rerender('606106ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point_shop/goods_form.vue"
export default component.exports